import { IconButton } from '@mui/material';
import React from 'react';
import { IconButtonFieldType } from '@/type';

interface IconButtonFieldControllerProps {
  iconButtonField: IconButtonFieldType;
}

const IconButtonFieldController = ({
  iconButtonField,
}: IconButtonFieldControllerProps) => {
  return (
    <IconButton
      id={iconButtonField.name}
      disabled={iconButtonField.disabled}
      onClick={iconButtonField.onClick}
      color={iconButtonField.color}
    >
      {iconButtonField.icon}
    </IconButton>
  );
};

export default IconButtonFieldController;
